import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

Swiper.use([Navigation, Pagination, Autoplay]);

let sliders = [],
    parent = document.querySelector('.leading-section .swiper'),
    leadingSlider = document.querySelectorAll('.leading-section .swiper .swiper-slide'),
    sliderNum = leadingSlider.length;

if (sliderNum >= 5) {
    parent.style.cssText = 'max-width: 1005px';
}

const swiper = new Swiper('.leading-section .swiper', {
    loop: sliderNum > 4,
    slidesPerView: 5,
    autoplay: {
        delay: 3000,
        disableOnInteraction: false,
    },
    centerInsufficientSlides: true,
    breakpoints: {
        0: {
            loop: sliderNum > 2.5,
            slidesPerView: 2.5,
            spaceBetween: 10,
            centeredSlides: true,
            centeredSlidesBounds: true,
        },
        480: {
            loop: sliderNum > 3,
            slidesPerView: 3,
            spaceBetween: 10,
            centeredSlides: true,
            centeredSlidesBounds: true,
        },
        768: {
            slidesPerView: 4,
        },
        1024: {
            slidesPerView: 5,
        },
    },
});

const masterChef = new Swiper('.master__chef .swiper', {
    loop: true,
    slidesPerView: 4,
    spaceBetween: 25,
    centerInsufficientSlides: true,
    autoplay: {
        delay: 3000,
        disableOnInteraction: false,
    },
    breakpoints: {
        0: {
            slidesPerView: 4.2,
            spaceBetween: 5,
        },
        480: {
            slidesPerView: 5,
            spaceBetween: 5,
        },
        768: {
            slidesPerView: 5,
            spaceBetween: 15,
        },
        1024: {
            slidesPerView: 5,
            spaceBetween: 15,
        },
    },
});

const masterhacksRelated = new Swiper('.masterhack__related .swiper', {
    loop: false,
    slidesPerView: 3,
    spaceBetween: 15,
    centerInsufficientSlides: true,
    navigation: {
        nextEl: '.button-next',
        prevEl: '.button-prev',
        clickable: true,
    },
    breakpoints: {
        '@0.00': {
            slidesPerView: 2.5,
            spaceBetween: 10,
            centeredSlides: true,
            centeredSlidesBounds: true,
        },
        '@0.48': {
            slidesPerView: 2.5,
            spaceBetween: 10,
            centeredSlides: true,
            centeredSlidesBounds: true,
        },
        '@1.00': {
            slidesPerView: 3,
            spaceBetween: 15,
        },
    },
});

const masterhacksMore = new Swiper('.masterhacks__more .swiper', {
    loop: false,
    slidesPerView: 3,
    spaceBetween: 10,
    centerInsufficientSlides: true,
    navigation: {
        nextEl: '.button-next',
        prevEl: '.button-prev',
        clickable: true,
    },
    breakpoints: {
        '@0.00': {
            slidesPerView: 2.5,
            spaceBetween: 10,
            centeredSlides: true,
            centeredSlidesBounds: true,
        },
        '@0.48': {
            slidesPerView: 2.5,
            spaceBetween: 10,
            centeredSlides: true,
            centeredSlidesBounds: true,
        },
        '@1.00': {
            slidesPerView: 3,
            spaceBetween: 15,
        },
    },
});

sliders.push(swiper, masterhacksRelated);

sliders.forEach((el) => {
    if (el.wrapperEl && el.autoplay.running) {
        if (el.params.slidesPerView >= sliderNum) {
            el.disable();
        }
    }
});
